import styled, { css } from 'styled-components';
const TabsCounter = css`
  visibility: ${props => props.visible ? 'visible' : 'hidden'};
  color: #a2a3b7;
  font-weight: 700;
  max-width: 0px;
  position: sticky;
  top: 0;
  &:hover {
    cursor: pointer;
    color: #4c5ecf;
    path {
      fill: #4c5ecf;
    }
  }
  &:active {
    color: #2235aa;
    path {
      fill: #2235aa;
    }
  }
`;
export const CounterWrapper = styled.div`
  height: 100%;
  position: absolute;
  width: 65px;
  display: flex;
  align-items: center;
  padding-bottom: 5px;
`;
export const PreviousTabsCounter = styled.div`
  ${TabsCounter}
  ${CounterWrapper} {
    padding-left: 6.5px;
    background: linear-gradient(
      90deg,
      #ffffff 69.64%,
      rgba(255, 255, 255, 0) 95.54%
    );
  }
  left: 0;
  z-index: 1;
`;
export const NextTabsCounter = styled.div`
  ${TabsCounter}
  ${CounterWrapper} {
    right: 0;
    justify-content: flex-end;
    padding-right: 6.5px;
    background: linear-gradient(
      270deg,
      #ffffff 69.64%,
      rgba(255, 255, 255, 0) 95.54%
    );
  }
  right: 0;
`;
export const Divider = styled.div`
  width: 100%;
  height: 5px;
  background: ${props => props.visible ? '#4c5ecf' : 'inherit'};
  border-radius: 10px 10px 0 0;
  transition: all ease-out 0.2s;
  margin-top: auto;
`;
export const BadgeWrapper = styled.div`
  margin-left: 4px;
  margin-top: -1px;
`;
export const Tab = styled.div`
  &&:nth-last-child(2) {
    margin-right: 0;
  }
  display: flex;
  flex-direction: column;
  color: ${props => props.active ? '#4C5ECF' : '#a2a3b7'};
  line-height: 33px;
  letter-spacing: 0.15px;
  font-weight: 700;
  cursor: pointer;
  transition: all ease-out 0.2s;
  user-select: none;
  ${props => props.disabled && 'color: rgba(162, 163, 183, 0.3); cursor: default'};
  white-space: nowrap;

  ${Divider} {
    ${props => props.disabled && 'background: inherit;'}
  }

  &:hover {
    ${props => !props.disabled && 'color: rgba(76, 94, 207, 1);'}
  }

  &:active {
    ${props => !props.disabled && 'color: #2235aa;'}
  }
`;
export const Content = styled.div`
  padding: 12px 0 8px 0;
`;
export const TabTitle = styled.div`
  display: flex;
`;
export const Header = styled.div`
  display: flex;
  border-bottom: 1px solid #e5e7f1;
  font-size: 12px;
  overflow-x: auto;
  ${props => props.invisibleHeaderScroll ? css`
          &::-webkit-scrollbar {
            display: none;
          }
        ` : ''}
  ${Tab} {
    ${props => props.gap ? `margin-right: ${props.gap}px` : ''};
  }
`;